import { produce } from 'immer';

import { EditInternalBanner } from '../../../actions/bannersEdit/internal/editInternalBanner';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function editInternalBanner(
    state: EditInternalBannersState,
    action: EditInternalBanner
): EditInternalBannersState {
    return produce(state, draft => {
        draft.banners[action.bannerId].isSaved = false;
    });
}
